import { createSlice, PayloadAction } from "@reduxjs/toolkit"

type DefaultState = {
  commonList: any
  page: number,
  prevPage: number,
  periodValue: number[],
  periodValueUI: number[]
  maxYear: number
  genresValue: number[]
}

const initialState: DefaultState = {
  commonList: [],
  page: 1,
  prevPage: 0,
  maxYear: 2025,
  periodValue: [1980, 2025],
  periodValueUI: [1980, 2025],
  genresValue: []
}

export const FavouritesListsSlice = createSlice({
  name: "lists",
  initialState: initialState,
  reducers: {
    setDataToFavouritesList: (state, action: PayloadAction<any>) => {
      state.commonList = action.payload?.length ? [...state.commonList, ...action.payload] : state.commonList;
    },
    setPrevFavouritesPage: (state, action: PayloadAction<number>) => {
      state.prevPage = action.payload
    },
    setFavouritesPage: (state, action: PayloadAction<number>) => {
      state.page = state.page + action.payload
    },
    cleanUpFavouritesPage: (state) => {
      state.page = 1;
      state.prevPage = 0;
      state.commonList = []
    },
    setPeriodFavouritesValue: (state, action: PayloadAction<number[]>) => {
      state.periodValue = action.payload
    },
    setPeriodFavouritesValueUI: (state, action: PayloadAction<number[]>) => {
      state.periodValueUI = action.payload
    },
    setGenresFavouritesValue: (state, action: PayloadAction<number[]>) => {
      state.genresValue = action.payload
    },
    setVoteCountFavourites: (state, action: PayloadAction<{id: number, key: string, type: string}>) => {
      const dat: any = [...state.commonList];
      const itemIndex = dat.findIndex((item: any) => item.id === action.payload.id);
      if (itemIndex !== -1) {
        dat[itemIndex] = {
          ...dat[itemIndex],
          vote_count: action.payload.type === 'increment' ? dat[itemIndex].vote_count + 1 : dat[itemIndex].vote_count - 1
        };
      }

      state.commonList = dat;
    },
    setMaxYearFavourites: (state, action: PayloadAction<number>) => {
      state.maxYear = action.payload;
      state.periodValue = [1980, action.payload]
      state.periodValueUI = [1980, action.payload]
    },
    resetGenresFavouritesValue: (state) => {
      state.genresValue = []
    }
  },
})

export default FavouritesListsSlice.reducer
export const {
  setDataToFavouritesList,
  setPrevFavouritesPage,
  setVoteCountFavourites,
  setMaxYearFavourites,
  setFavouritesPage,
  cleanUpFavouritesPage,
  setPeriodFavouritesValue,
  setPeriodFavouritesValueUI,
  setGenresFavouritesValue,
  resetGenresFavouritesValue
} = FavouritesListsSlice.actions
